import styled from "styled-components"
import media from "styleguide/styles/media-queries"

const H4 = styled.h4`
  font-weight: 800;
  &,
  * {
    font-size: 22px;
    line-height: 32px;
  }

  ${media.tablet`
    &, * {
      font-size: 18px;
      line-height: 24px
    }
  `}
`

export default H4
